
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, PanelLeft } from 'lucide-react';
import { useIsMobile } from '../../hooks/use-mobile';
import { SidebarTrigger } from "@/components/ui/sidebar";
import { NotificationBell } from "@/components/notifications/NotificationBell";

interface HeaderProps {
  title: string;
  showBackButton?: boolean;
  rightAction?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, showBackButton = false, rightAction }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-10">
      <div className="max-w-screen-sm mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <SidebarTrigger className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">
              <PanelLeft size={20} className="text-gray-600 dark:text-gray-300" />
            </SidebarTrigger>
            {showBackButton && (
              <button
                onClick={() => navigate(-1)}
                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
              >
                <ArrowLeft size={20} className="text-gray-600 dark:text-gray-300" />
              </button>
            )}
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h1>
          </div>
          <div className="flex items-center space-x-2">
            <NotificationBell />
            {rightAction}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
